import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ApiService} from '../../../api.service';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.css']
})
export class AreaComponent implements OnInit {

  area: {} = [];
  constructor(public restApi: ApiService) { }

  @Input()
  provinceID: number;

  @Output()
  selectedAreaID: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges) {
    this.loadArea();
  }

  // Get employees list
  loadArea() {
    return this.restApi.getArea(this.provinceID).subscribe((data: {}) => {
      console.log(data);
      this.area = data;
    });
  }

  onChange(message) {
    this.selectedAreaID.emit(message);
  }
}
